// extracted by mini-css-extract-plugin
module.exports = {"container":"Popover_container__GOha0","trigger":"Popover_trigger__qKXNN","content":"Popover_content__gu5L4","tooltipContent":"Popover_tooltipContent__AMPpT"};